var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeForIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7824 2.1992L19.2774 6.67511C19.5435 6.94006 19.5679 7.3546 19.3505 7.64699L19.278 7.73077L14.783 12.2168C14.4904 12.5087 14.0155 12.5092 13.7223 12.2179C13.4558 11.953 13.4311 11.5381 13.6486 11.2456L13.7212 11.1617L16.938 7.95232L5.24219 7.95298C4.86249 7.95298 4.5487 7.67201 4.49903 7.30747L4.49219 7.20613C4.49219 6.82803 4.77434 6.51554 5.14042 6.46609L5.24219 6.45927L16.94 6.45861L13.7218 3.25545C13.4555 2.99031 13.4313 2.57539 13.6491 2.28301L13.7217 2.19924C13.988 1.93408 14.4047 1.90996 14.6983 2.12689L14.7824 2.1992ZM19.5002 16.5681L19.507 16.6695C19.507 17.0476 19.2249 17.3601 18.8588 17.4095L18.757 17.4164L7.06103 17.4155L10.2822 20.6214C10.5486 20.8865 10.5729 21.3014 10.3552 21.5939L10.2826 21.6776C10.0165 21.9429 9.59982 21.9672 9.30612 21.7503L9.22197 21.6781L4.72197 17.2007C4.45559 16.9357 4.43121 16.5207 4.64894 16.2283L4.72153 16.1445L9.22153 11.6596C9.5143 11.3678 9.98917 11.3676 10.2822 11.6591C10.5486 11.9242 10.5729 12.3392 10.3552 12.6316L10.2826 12.7154L7.06503 15.9218L18.757 15.9227C19.1367 15.9227 19.4505 16.2036 19.5002 16.5681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeForIcon);
export default __webpack_public_path__ + "static/media/trade-for-icon.3bb0b6267abf1c71f9fcea84ec8d35f0.svg";
export { ForwardRef as ReactComponent };